var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      attrs: { name: "search-card-collection", width: 0 },
      on: { "before-open": _vm.onBeforeOpen }
    },
    [
      _c(
        "div",
        {
          staticClass:
            "modal show modal__search-card-collection modal__new_design"
        },
        [
          _c(
            "section",
            {
              directives: [
                {
                  name: "click-outside",
                  rawName: "v-click-outside",
                  value: _vm.hide,
                  expression: "hide"
                }
              ]
            },
            [
              _c("a", { staticClass: "modal__close" }, [
                _c("i", { staticClass: "icon-close", on: { click: _vm.hide } })
              ]),
              _vm._v(" "),
              _vm.modalParams
                ? _c("SearchCardCollection", {
                    key: _vm.modalParams.openForGroupSave,
                    attrs: {
                      openForGroupSave: _vm.modalParams.openForGroupSave
                    },
                    on: { close: _vm.hide }
                  })
                : _vm._e()
            ],
            1
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }